// separate restangular instance for calls against `/api`
// main/base Restangular's baseUrl is configured as `/internal/v1`
// see: webapp/src/app/index.js
//
// This does NOT currently implement any errorInterceptor features
// (routing to redirect / sign_out based on response)
export function ApiRestangular(Restangular) {
  'ngInject';
  return Restangular.withConfig((RestangularConfigurer) => {
    RestangularConfigurer.setBaseUrl(`${Restangular.configuration.baseUrl}/api`);
    // Configure the id column to be 'id'
    // This is overriding the global setting of 'key' (leftover from Datastore?)
    // https://github.com/agosto-dev/skykit-adminconsole/blob/5a46ea3/webapp/src/app/index.js#L137-L139
    RestangularConfigurer.setRestangularFields({
      id: 'id',
    });
  });
}
